import { format, parseISO } from 'date-fns';
import { CalendarDays } from 'lucide-react';
import { PillBadge } from '@/components/common/PillBadge';
import { getBangladeshToday } from '@/features/moTravel/utils/bangladeshClock';

const TODAY_FORMAT = 'EEEE, dd MMM yyyy';

export function TodayBadge() {
  return (
    <PillBadge icon={CalendarDays} screenReaderLabel="Today:">
      {format(parseISO(getBangladeshToday()), TODAY_FORMAT)}
    </PillBadge>
  );
}
